// Die REST-Antwort liefert unter 'groups' ein Array von Tabellen-Blöcken (ein Block pro Liga/Gruppe).
// Filterung direkt über leagueID (== unsere ligaId aus dem Match) statt Team-Suche.
export function tabelleFuerLiga(alleTabellen, ligaId) {
  if (!Array.isArray(alleTabellen) || ligaId == null) return []
  return alleTabellen.filter(block => block.id === ligaId)
}